import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { Button, Accordion } from 'react-bootstrap';
import './WelcomePage.css';

const WelcomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="welcome-landing">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-badge">
            <Icon icon="mdi:star" />
            <span>Manual Completo da Plataforma</span>
          </div>
          <h1 className="hero-title">
            Bem-vindo à <span className="gradient-text">Pagmus</span>
          </h1>
          <p className="hero-subtitle">
            Sua plataforma completa para vender produtos físicos, gerenciar afiliados e maximizar seus resultados. 
            Tudo que você precisa saber para começar está aqui.
          </p>
          <div className="hero-buttons">
            <Button className="btn-primary-gradient" onClick={() => window.scrollTo({ top: document.querySelector('.features-overview-section').offsetTop, behavior: 'smooth' })}>
              <Icon icon="mdi:star" />
              Funcionalidades
            </Button>
            <Button className="btn-secondary-outline" onClick={() => window.scrollTo({ top: document.querySelector('.business-rules-section').offsetTop, behavior: 'smooth' })}>
              <Icon icon="mdi:shield-check" />
              Regras de Negócios
            </Button>
            <Button className="btn-secondary-outline" onClick={() => window.scrollTo({ top: document.querySelector('.faq-section').offsetTop, behavior: 'smooth' })}>
              <Icon icon="mdi:help-circle" />
              Dúvidas
            </Button>
          </div>
        </div>
      </section>

      {/* Features Overview */}
      <section className="features-overview-section">
        <div className="section-header">
          <span className="section-badge">Funcionalidades</span>
          <h2 className="section-title">Tudo que você precisa para vender mais, em um só lugar</h2>
          <p className="section-subtitle">
            Gerencie seus produtos, conecte afiliados e controle tudo em tempo real.
          </p>
        </div>

        <div className="features-grid">
          <div className="feature-row">
            <div className="feature-block feature-products">
              <div className="feature-visual">
                <div className="icon-circle">
                  <Icon icon="mdi:package-variant-closed" />
                </div>
              </div>
              <div className="feature-content">
                <h3>Produtos Físicos</h3>
                <p>
                  Venda seus produtos físicos com agilidade e eficiência. Personalize checkouts, conecte ferramentas de marketing e logística e proporcione uma jornada de compra completa ao seu cliente.
                </p>
                <ul className="feature-list">
                  <li><Icon icon="mdi:check-circle" /> Cadastre seus produtos ou afilie-se a ofertas da loja</li>
                  <li><Icon icon="mdi:check-circle" /> Crie planos e checkouts totalmente personalizáveis</li>
                  <li><Icon icon="mdi:check-circle" /> Aumente suas conversões com taxa mínima de recusa de cartão</li>
                  <li><Icon icon="mdi:check-circle" /> Aproveite a menor taxa do mercado para vender mais e lucrar melhor</li>
                </ul>
                <Button className="btn-feature" onClick={() => navigate('/products/products')}>
                  Gerenciar Produtos
                  <Icon icon="mdi:arrow-right" />
                </Button>
              </div>
            </div>

            <div className="feature-block feature-affiliates">
              <div className="feature-visual">
                <div className="icon-circle">
                  <Icon icon="mdi:account-group" />
                </div>
              </div>
              <div className="feature-content">
                <h3>Sistema de Afiliados</h3>
                <p>
                  Expanda seu alcance e aumente suas vendas com um sistema completo de afiliados. Gerencie comissões, personalize regras e acompanhe tudo em tempo real com total transparência.
                </p>
                <ul className="feature-list">
                  <li><Icon icon="mdi:check-circle" /> Links de afiliação únicos e rastreáveis</li>
                  <li><Icon icon="mdi:check-circle" /> Rastreamento de vendas em tempo real</li>
                  <li><Icon icon="mdi:check-circle" /> Comissões totalmente personalizáveis</li>
                  <li><Icon icon="mdi:check-circle" /> Split de pagamento automatizado e seguro</li>
                </ul>
                <Button className="btn-feature" onClick={() => navigate('/my-affiliates')}>
                  Ver Afiliados
                  <Icon icon="mdi:arrow-right" />
                </Button>
              </div>
            </div>
          </div>

          <div className="feature-row">
            <div className="feature-block feature-reports">
              <div className="feature-visual">
                <div className="icon-circle">
                  <Icon icon="mdi:chart-line" />
                </div>
              </div>
              <div className="feature-content">
                <h3>Relatórios e Analytics</h3>
                <p>
                  Monitore suas vendas e acompanhe a performance do seu negócio em tempo real com dashboards interativos e dados acionáveis. Obtenha insights valiosos, automatize processos e tome decisões com base em informações precisas.
                </p>
                <ul className="feature-list">
                  <li><Icon icon="mdi:check-circle" /> Dashboard completo com métricas em tempo real</li>
                  <li><Icon icon="mdi:check-circle" /> Visualização exclusiva para Afterpay</li>
                  <li><Icon icon="mdi:check-circle" /> Kanban automático sincronizado com os Correios</li>
                  <li><Icon icon="mdi:check-circle" /> Exportação de dados em CSV e Excel para análise avançada</li>
                </ul>
                <Button className="btn-feature" onClick={() => navigate('/sales-management')}>
                  Ver Relatórios
                  <Icon icon="mdi:arrow-right" />
                </Button>
              </div>
            </div>

            <div className="feature-block feature-payments">
              <div className="feature-visual">
                <div className="icon-circle">
                  <Icon icon="mdi:cash-multiple" />
                </div>
              </div>
              <div className="feature-content">
                <h3>Pagamentos Seguros</h3>
                <p>
                  Receba pagamentos e comissões com agilidade, segurança e total transparência. Reduza recusas de cartão, antecipe valores quando precisar e conte com uma das menores taxas do mercado.
                </p>
                <ul className="feature-list">
                  <li><Icon icon="mdi:check-circle" /> Processamento seguro com taxas personalizáveis</li>
                  <li><Icon icon="mdi:check-circle" /> Sistema antifraude inteligente e baixa rejeição de transações</li>
                  <li><Icon icon="mdi:check-circle" /> Antecipações e saques rápidos, com aprovação facilitada</li>
                  <li><Icon icon="mdi:check-circle" /> Histórico completo de pagamentos e saques, sempre acessível</li>
                </ul>
                <Button className="btn-feature" onClick={() => navigate('/withdrawals')}>
                  Gerenciar Pagamentos
                  <Icon icon="mdi:arrow-right" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Getting Started */}
      <section className="getting-started-section">
        <div className="section-header">
          <span className="section-badge">Guia Inicial</span>
          <h2 className="section-title">Como começar em 4 passos simples</h2>
          <p className="section-subtitle">
            Siga este guia passo a passo para configurar sua conta e começar a vender
          </p>
        </div>

        <div className="steps-grid">
          <div className="step-card">
            <div className="step-content">
              <span className="step-title">Cadastre um Responsável</span>
              <p>
                Antes de cadastrar produtos, você precisa criar um <strong>responsável pela conta</strong>. 
                Este responsável passará por um processo de aprovação de dados para garantir a segurança 
                da plataforma.
              </p>
              <div className="step-info">
                <Icon icon="mdi:information" />
                <span>Aprovação em até 2 dias úteis.</span>
              </div>
              <Button className="btn-step" onClick={() => navigate('/responsibles')}>
                <Icon icon="mdi:plus" />
                Cadastrar Responsável
              </Button>
            </div>
          </div>

          <div className="step-card">
            <div className="step-content">
              <span className="step-title">Cadastre sua Conta Bancária</span>
              <p>
                Para receber seus pagamentos e comissões, é necessário cadastrar uma <strong>conta 
                bancária vinculada ao responsável aprovado</strong>. Você pode cadastrar múltiplas 
                contas e escolher qual usar.
              </p>
              <div className="step-info">
                <Icon icon="mdi:shield-check" />
                <span>Dados criptografados e seguros</span>
              </div>
              <Button className="btn-step" onClick={() => navigate('/banks')}>
                <Icon icon="mdi:plus" />
                Cadastrar Conta
              </Button>
            </div>
          </div>

          <div className="step-card">
            <div className="step-content">
              <span className="step-title">Cadastre um Produto</span>
              <p>
                Com o responsável aprovado, você pode cadastrar seus <strong>produtos físicos</strong>. 
                Defina preços, variações, imagens e todas as informações necessárias.
              </p>
              <div className="step-info">
                <Icon icon="mdi:clock-fast" />
                <span>Produtos aprovados em até 24 horas</span>
              </div>
              <Button className="btn-step" onClick={() => navigate('/products/registration/new')}>
                <Icon icon="mdi:plus" />
                Novo Produto
              </Button>
            </div>
          </div>

          <div className="step-card">
            <div className="step-content">
              <span className="step-title">Afilie-se a Produtos</span>
              <p>
                Quer promover produtos de outros? Acesse a <strong>Loja</strong> e solicite afiliação 
                aos produtos disponíveis. Após aprovação, você poderá promover e ganhar comissões.
              </p>
              <div className="step-info">
                <Icon icon="mdi:percent" />
                <span>Comissões competitivas</span>
              </div>
              <Button className="btn-step" onClick={() => navigate('/store/store-products')}>
                <Icon icon="mdi:shopping" />
                Ver Loja
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Business Rules */}
      <section className="business-rules-section">
        <div className="section-header">
          <span className="section-badge">Regras & Políticas</span>
          <h2 className="section-title">Regras de Negócio</h2>
          <p className="section-subtitle">
            Entenda as políticas e regras importantes da plataforma
          </p>
        </div>

        <div className="rules-grid">
          <div className="rule-row">
            <div className="rule-card">
              <div className="rule-icon" style={{ background: '#10B98115', color: '#10B981' }}>
                <Icon icon="mdi:cash-multiple" />
              </div>
              <h3>Saques</h3>
              <div className="rule-items">
                <div className="rule-item">
                  <Icon icon="mdi:check-circle" />
                  <div>
                    <strong>Valor Mínimo:</strong> R$ 100,00
                  </div>
                </div>
                <div className="rule-item">
                  <Icon icon="mdi:check-circle" />
                  <div>
                    <strong>Frequência:</strong> 1 saque por dia
                  </div>
                </div>
                <div className="rule-item">
                  <Icon icon="mdi:check-circle" />
                  <div>
                    <strong>Aprovação:</strong> Até 2 dias úteis.
                  </div>
                </div>
                <div className="rule-item">
                  <Icon icon="mdi:check-circle" />
                  <div>
                    <strong>Recebimento:</strong> 1 dia útil.
                  </div>
                </div>
              </div>
            </div>

            <div className="rule-card">
              <div className="rule-icon" style={{ background: '#EC489915', color: '#EC4899' }}>
                <Icon icon="mdi:percent" />
              </div>
              <h3>Comissões</h3>
              <div className="rule-items">
                <div className="rule-item">
                  <Icon icon="mdi:check-circle" />
                  <div>
                    <strong>Taxa:</strong> Definida pelo produtor
                  </div>
                </div>
                <div className="rule-item">
                  <Icon icon="mdi:check-circle" />
                  <div>
                    <strong>Pagamento:</strong> Automático após confirmação
                  </div>
                </div>
                <div className="rule-item">
                  <Icon icon="mdi:check-circle" />
                  <div>
                    <strong>Rastreamento:</strong> Via cookies de afiliado
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="rule-row">
            <div className="rule-card">
              <div className="rule-icon" style={{ background: '#6366F115', color: '#6366F1' }}>
                <Icon icon="mdi:package-variant" />
              </div>
              <h3>Produtos</h3>
              <div className="rule-items">
                <div className="rule-item">
                  <Icon icon="mdi:check-circle" />
                  <div>
                    <strong>Facilidade:</strong> Facilidade na criação do produto
                  </div>
                </div>
                <div className="rule-item">
                  <Icon icon="mdi:check-circle" />
                  <div>
                    <strong>Autonomia:</strong> Configure planos, ofertas e checkouts personalizáveis.
                  </div>
                </div>
                <div className="rule-item">
                  <Icon icon="mdi:check-circle" />
                  <div>
                    <strong>Gerenciamento:</strong> Gerencie seus afiliados e comissões por produto.
                  </div>
                </div>
              </div>
            </div>

            <div className="rule-card">
              <div className="rule-icon" style={{ background: '#F59E0B15', color: '#F59E0B' }}>
                <Icon icon="mdi:shield-check" />
              </div>
              <h3>Segurança</h3>
              <div className="rule-items">
                <div className="rule-item">
                  <Icon icon="mdi:check-circle" />
                  <div>
                    <strong>Dados:</strong> Criptografados e protegidos
                  </div>
                </div>
                <div className="rule-item">
                  <Icon icon="mdi:check-circle" />
                  <div>
                    <strong>Pagamentos:</strong> Via Pagar.me (PCI Compliant)
                  </div>
                </div>
                <div className="rule-item">
                  <Icon icon="mdi:check-circle" />
                  <div>
                    <strong>Verificação:</strong> Processo de autenticidade
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="section-header">
          <span className="section-badge">Perguntas Frequentes</span>
          <h2 className="section-title">Tire suas dúvidas</h2>
          <p className="section-subtitle">
            Respostas para as perguntas mais comuns sobre a plataforma
          </p>
        </div>

        <div className="faq-container">
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0" className="faq-item">
              <Accordion.Header>
                <Icon icon="mdi:help-circle" />
                Como faço para cadastrar um responsável?
              </Accordion.Header>
              <Accordion.Body>
                Acesse o menu <strong>Financeiro › Responsáveis</strong> e clique em "Novo Responsável". 
                Preencha todos os dados solicitados. O responsável passará por um processo de aprovação 
                que pode levar até 48 horas.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1" className="faq-item">
              <Accordion.Header>
                <Icon icon="mdi:help-circle" />
                Quando posso solicitar meu primeiro saque?
              </Accordion.Header>
              <Accordion.Body>
                Você pode solicitar um saque assim que tiver saldo disponível de pelo menos 
                <strong> R$ 100,00</strong> e uma conta bancária aprovada cadastrada.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2" className="faq-item">
              <Accordion.Header>
                <Icon icon="mdi:help-circle" />
                Como me torno afiliado de um produto?
              </Accordion.Header>
              <Accordion.Body>
                Acesse a <strong>Loja</strong>, encontre o produto desejado e clique em 
                "Solicitar Afiliação". O produtor analisará sua solicitação e você receberá 
                uma notificação.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3" className="faq-item">
              <Accordion.Header>
                <Icon icon="mdi:help-circle" />
                Quando recebo minhas comissões?
              </Accordion.Header>
              <Accordion.Body>
                As comissões são creditadas automaticamente após a confirmação do pagamento da venda. 
                O prazo varia conforme a forma de pagamento (cartão: imediato, boleto: após compensação).
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4" className="faq-item">
              <Accordion.Header>
                <Icon icon="mdi:help-circle" />
                Há taxa para realizar saques?
              </Accordion.Header>
              <Accordion.Body>
                Sim, a plataforma cobra uma <strong>taxa por saque realizado</strong>. Além disso, também cobramos um 
                <strong> percentual de desconto para antecipação de recebíveis</strong>, caso você opte por antecipar 
                seus valores antes do prazo de repasse padrão. As taxas podem variar de acordo com seu volume de vendas, 
                desempenho e assiduidade na plataforma.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5" className="faq-item">
              <Accordion.Header>
                <Icon icon="mdi:help-circle" />
                Como cadastro um novo produto?
              </Accordion.Header>
              <Accordion.Body>
                Acesse <strong>Produtos › Novo Produto</strong>. Preencha todas as informações 
                necessárias incluindo título, descrição, preço e imagens. O produto passará 
                por análise antes de ficar disponível.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>

        {/* Contact CTA */}
        <div className="contact-cta">
          <div className="contact-icon">
            <Icon icon="mdi:lifebuoy" />
          </div>
          <h3>Ainda tem dúvidas?</h3>
          <p>Nossa equipe está pronta para ajudar você!</p>
          <div className="contact-buttons">
            <Button className="btn-primary-gradient" onClick={() => navigate('/tickets')}>
              <Icon icon="mdi:ticket-account" />
              Entrar em Contato
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="welcome-footer">
        <p>© 2025 Pagmus - Sua plataforma completa de vendas e afiliados</p>
      </footer>
    </div>
  );
};

export default WelcomePage;
